import { select, call } from "redux-saga/effects";
import { isRegisteredShopper as isRegisteredShopperPromise } from "@bitComponents/adabyron/register";

const contextStore = (state) => state.context.data;

export function* isRegisteredShopper() {
  try {
    const context = yield select(contextStore);
    const response = yield call(isRegisteredShopperPromise, context);
    return response;
  } catch (error) {
    console.log(error);
    throw error;
  }
}
